// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__32x0L","head":"ProcedureTableInfo_head__1pLon"};